export default __webpack_public_path__ + "static/media/PFSquareSansProRegular_35489.b9e248eb.ttf";